import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import Form from "@common/externos/components/validation/form.validation";
import autoBind from "react-autobind";
import DDados from '../habitese.ddados';
import { Row, Col } from "react-bootstrap";
import DDadosItem from "@common/components/ddados/ddados.item";
import habiteseSelectors from '../store/habitese.selectors';
import habiteseActions from '../store/habitese.actions';
import Address from "@common/components/address/components/address.component";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    this.props.habiteseActions.getDadosHabitese();
  }

  componentWillUnmount(){
    window.sessionStorage.removeItem('habitese');
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: "obrasParticulares.validarHabitese" });
  }

  render() {
    const { Campos } = DDados;
    const { title, onPrintReport, prefix, habiteseSelectors } = this.props;
    const { DadosHabitese } = habiteseSelectors.habitese;
    const { ProfissionalProjeto,  ProfissionalExecucao} = DadosHabitese;
    const isView = prefix == "V";

    return (
      <Form
        onPrintReport={onPrintReport}
        boxForm
        onCancel={this.onCancel}
        prefix={prefix}
        title={title}
        formControl={true}
        isView={isView}
      >
        {form => (
            <Fragment>
              <Row>
                <Col lg={3}>
                  <DDadosItem name="Protocolo" {...Campos.Protocolo} state={DadosHabitese} isView={isView} />
                </Col>
                <Col lg={3}>
                  <DDadosItem name="Processo" {...Campos.Processo} state={DadosHabitese} isView={isView} />
                </Col>
                <Col lg={3}>
                  <DDadosItem name="Projeto" {...Campos.Projeto} state={DadosHabitese} isView={isView} />
                </Col>
                <Col lg={3}>
                  <DDadosItem name="DataInicioObra" {...Campos.DataInicioObra} state={DadosHabitese} isView={isView} />
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <DDadosItem name="Solicitante" {...Campos.Solicitante} state={DadosHabitese} isView={isView} />
                </Col>
              </Row>
              <Row>
                <Col lg={9}>
                  <DDadosItem name="ResponsavelProjeto" {...Campos.ResponsavelProjeto} state={DadosHabitese}
                    isView={isView} />
                </Col>
                <Col lg={3}>
                  {ProfissionalProjeto ? (
                    <DDadosItem name="ArtProjeto" {...Campos.ArtProjeto} state={DadosHabitese} isView={isView} />
                  ) : (
                    <DDadosItem name="RrtProjeto" {...Campos.RrtProjeto} state={DadosHabitese} isView={isView} />
                  )}
                </Col>
              </Row>
              <Row>
                <Col lg={9}>
                  <DDadosItem name="ResponsavelExecucao" {...Campos.ResponsavelExecucao} state={DadosHabitese}
                    isView={isView} />
                </Col>
                <Col lg={3}>
                  {ProfissionalExecucao ? (
                    <DDadosItem name="ArtExecucao" {...Campos.ArtExecucao} state={DadosHabitese} isView={isView} />
                  ) : (
                    <DDadosItem name="RrtExecucao" {...Campos.RrtExecucao} state={DadosHabitese} isView={isView} />
                  )}
                </Col>
              </Row>
              <Row>
                <Col lg={3}>
                  <DDadosItem name="NumeroHabitese" {...Campos.NumeroHabitese} state={DadosHabitese} isView={isView} />
                </Col>
                <Col lg={3}>
                  <DDadosItem name="DataEmissaoHabitese" {...Campos.DataEmissaoHabitese} state={DadosHabitese}
                    isView={isView} />
                </Col>
                <Col lg={3}>
                  <DDadosItem name="TipoHabitese" {...Campos.TipoHabitese} state={DadosHabitese} isView={isView} />
                </Col>
                <Col lg={3}>
                  <DDadosItem name="AlvaraReferente" {...Campos.AlvaraReferente} state={DadosHabitese}
                    isView={isView} />
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <DDadosItem name="Proprietario" {...Campos.Proprietario} state={DadosHabitese} isView={isView} />
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <Address
                    name="Endereco"
                    state={DadosHabitese.Endereco}
                    prefix={prefix}
                  />
                </Col>
             </Row>
           </Fragment>
          )}
      </Form>
    );
  }
}

export default connect({
  selectors: {
    habiteseSelectors,
  },
  actions: {
    habiteseActions,
  },
})(Container);
